import React from "react";
import { motion } from "framer-motion";
import { Crown, Lock, PlayCircle } from "lucide-react";
import { youtubeEmbed } from "../../lib/video";

const GOLD = "#D4AF37";

// Tier-3 personal video message. Elite + link -> video; Elite + no link -> hidden;
// non-Elite -> locked upsell teaser.
export default function EliteGreeting({ player, isElite, onLockedClick }) {
  const link = player?.elite_video_url || "";
  const embed = youtubeEmbed(link);

  if (isElite) {
    if (!embed) return null; // clean empty state
    return (
      <motion.section
        data-testid="elite-greeting"
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="mb-8 rounded-2xl border p-5 sm:p-6 backdrop-blur-xl"
        style={{ borderColor: `${GOLD}40`, background: "linear-gradient(135deg, rgba(212,175,55,0.12), rgba(20,20,20,0.6))" }}>
        <div className="flex items-center gap-2.5 mb-4">
          <span className="flex h-8 w-8 items-center justify-center rounded-full" style={{ background: `${GOLD}26` }}>
            <Crown size={16} style={{ color: GOLD }} />
          </span>
          <div>
            <div className="text-[10px] font-bold uppercase tracking-[0.25em]" style={{ color: GOLD }}>Elite · Just For You</div>
            <h2 className="font-headings text-lg sm:text-xl uppercase tracking-wide">A Personal Message from Coach Barker</h2>
          </div>
        </div>
        <div className="relative w-full rounded-xl overflow-hidden border" style={{ aspectRatio: "16 / 9", borderColor: `${GOLD}33` }}>
          <iframe title="Personal Message from Coach Barker" src={embed} className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
        </div>
      </motion.section>
    );
  }

  // Non-Elite: locked teaser (upsell)
  return (
    <motion.button
      data-testid="elite-greeting-locked"
      onClick={onLockedClick}
      initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
      className="mb-8 w-full text-left rounded-2xl border border-white/10 bg-[#141414] p-5 sm:p-6 relative overflow-hidden group hover:border-[#D4AF37]/40 transition-colors">
      <div className="flex items-center gap-2.5 mb-3">
        <span className="flex h-8 w-8 items-center justify-center rounded-full" style={{ background: `${GOLD}1a` }}>
          <Crown size={16} style={{ color: GOLD }} />
        </span>
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-white/40">Elite Coaching</div>
          <h2 className="font-headings text-lg sm:text-xl uppercase tracking-wide text-white/70">Personal Coach Videos</h2>
        </div>
      </div>
      <div className="flex items-center gap-3 rounded-xl border border-dashed border-white/15 bg-[#0d0d0d] px-4 py-6 justify-center">
        <Lock size={18} className="text-[#D4AF37]" />
        <span className="text-sm text-white/55">Elite members get video messages recorded just for them. <span className="font-semibold text-white/80 underline decoration-[#D4AF37]/50">Unlock with Elite</span></span>
        <PlayCircle size={18} className="text-white/30" />
      </div>
    </motion.button>
  );
}
